import axios from "axios";
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";

const options = {
	colors: ["#3C50E0", "#00B05F"],
	chart: {
		fontFamily: "Satoshi, sans-serif",
		type: "bar",
		height: 335,
		toolbar: {
			show: false,
		},
		zoom: {
			enabled: false,
		},
	},

	responsive: [
		{
			breakpoint: 1536,
			options: {
				plotOptions: {
					bar: {
						borderRadius: 0,
						columnWidth: "40%",
					},
				},
			},
		},
	],
	plotOptions: {
		bar: {
			horizontal: false,
			borderRadius: 4,
			columnWidth: "40%",
			distributed: true,
		},
	},
	dataLabels: {
		enabled: true,
	},

	xaxis: {
		categories: ["Invites", "Requests"],
	},
	legend: {
		show: false,
	},
	fill: {
		opacity: 1,
	},
};

const ChartTwo = () => {
	const user = useSelector((st) => st.user).user;
	const [totals, setTotals] = useState({
		invites: 0,
		requests: 0,
	});

	useEffect(() => {
		fetchTotals();
	}, []);

	const fetchTotals = async () => {
		const headers = {
			Authorization: `Bearer ${user?.token}`,
		};
		try {
			const [invitesRes, requestsRes] = await Promise.all([
				axios.get(
					`${process.env.REACT_APP_API_URL}/api/v1/send-invitations/user-stats`,
					{ headers }
				),
				axios.get(
					`${process.env.REACT_APP_API_URL}/api/v1/send-requests/user-stats`,
					{ headers }
				),
			]);
			setTotals({
				invites: invitesRes.data.data.totalCount || 0,
				requests: requestsRes.data.data.totalCount || 0,
			});
		} catch (error) {
			console.error("Failed to fetch invites/requests totals:", error);
		}
	};

	const series = [
		{
			name: "Total",
			data: [totals.invites, totals.requests],
		},
	];

	return (
		<div className="col-span-12 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm xl:col-span-4">
			<div className="mb-4 justify-between gap-4 sm:flex">
				<div>
					<h4 className="text-lg font-semibold text-slate-800">
						Invites & Requests
					</h4>
					<p className="mt-1 text-sm text-slate-500">Total across all users</p>
				</div>
			</div>

			<div>
				<div id="chartTwo">
					<ReactApexChart
						options={options}
						series={series}
						type="bar"
						height={350}
					/>
				</div>
			</div>
		</div>
	);
};

export default ChartTwo;
